import type { GetStaticProps } from 'next';
import { ArticleTopicRow } from '../../components/article-topic-row';
import { Box } from '../../components/box';
import { PageMeta } from '../../contentful-components/page-meta';
import { SectionResolver } from '../../contentful-components/section-resolver';
import { getOrCreateContentfulClient } from '../../graphql/client';
import type { PageFragment } from '../../graphql/fragments/PageFragment.graphql';
import type { PageMetaFragment } from '../../graphql/fragments/PageMetaFragment.graphql';
import { getAllArticlesByTopic } from '../../graphql/hooks/article-topic-page';
import type { GetAllArticlesByTopicQuery } from '../../graphql/queries/GetAllArticlesByTopic.graphql';
import { fetchContentfulPage } from '../../lib/static/fetchStaticPage';
import { DEFAULT_PAGE_TTL } from '../../lib/static/static-page';
import type { PageWithContext } from '../../lib/utils/context';
import { PAGE_OPTIONS } from '../../lib/utils/page';
export const getStaticProps: GetStaticProps = async context => {
  const slug = PAGE_OPTIONS.MONEY_101.slug;
  const name = PAGE_OPTIONS.MONEY_101.meta.name;
  try {
    const client = getOrCreateContentfulClient(`/money-101`);
    const [page, topics] = await Promise.all([fetchContentfulPage(slug), getAllArticlesByTopic(client)]);
    return {
      props: {
        slug: slug ?? context?.params?.slug,
        page,
        topicData: topics.data,
        name: name
      },
      revalidate: DEFAULT_PAGE_TTL
    };
  } catch (error) {
    return {
      notFound: true
    };
  }
};
const Money101Page: PageWithContext<{
  page: PageFragment;
  meta: PageMetaFragment;
  topicData: GetAllArticlesByTopicQuery;
}> = ({
  page,
  meta,
  topicData
}) => {
  const [banner, ...sections] = page?.sections?.items ?? [];
  return <>
            {meta && <PageMeta id={meta.sys.id} meta={meta} name={PAGE_OPTIONS.MONEY_101.meta.name} />}

            <SectionResolver sections={banner ? [banner] : []} data-sentry-element="SectionResolver" data-sentry-source-file="index.tsx" />

            {topicData?.topics?.items.map(topic => <ArticleTopicRow key={topic.slug} topic={topic} />)}

            <Box pad={['vertical']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
                <SectionResolver sections={sections ?? []} data-sentry-element="SectionResolver" data-sentry-source-file="index.tsx" />
            </Box>
        </>;
};
export default Money101Page;